import * as React from 'react';
import {
  Heading,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';

type Props = {
  id: string;
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * One top-level audit section (Colors / Typography / Icons /
 * Components / Molecules). `id` is the anchor the in-page nav in
 * DesignSystemPage links to.
 */
export const Section = ({ id, title, description, children }: Props) => (
  <VStack
    id={id}
    gap={4}
    align="stretch"
    pb={12}
    style={{ scrollMarginTop: '72px' }}
  >
    <VStack gap={1} align="stretch">
      <Heading size="lg">{title}</Heading>
      {description && <Text maxW="720px">{description}</Text>}
    </VStack>

    {children}
  </VStack>
);
